import {make} from './brandedType'
import {QuizQuestionId} from './types'

// Learn LLM cost is tracked as an integer 'tokens' unit rather than a dollar float
// to fit in subscriber_lifetime_quotas.amount's int4
export const LEARN_COST_TOKENS_PER_DOLLAR = 1000

export function learnCostTokensToDollars(tokens: number): number {
  return tokens / LEARN_COST_TOKENS_PER_DOLLAR
}

const quizQuestionIdFactory = make<QuizQuestionId>()
export function makeQuizQuestionId(quizJobId: string, quizQuestionIndex: number): QuizQuestionId {
  return quizQuestionIdFactory(`${quizJobId}:${quizQuestionIndex}`)
}

export function unpackQuizQuestionId(questionId: QuizQuestionId) {
  const [quizJobId, quizQuestionIndexStr] = questionId.split(':') as [string, string]
  return {quizJobId, quizQuestionIndex: Number(quizQuestionIndexStr)}
}
